import icon1 from "../../../assets/images/personalization-icon1.svg";
import icon2 from "../../../assets/images/personalization-icon2.svg";
import icon3 from "../../../assets/images/personalization-icon3.svg";
import icon4 from "../../../assets/images/personalization-icon4.svg";
import icon5 from "../../../assets/images/personalization-icon5.svg";

export const makeItem = (extra = {}) => ({ id: crypto.randomUUID(), ...extra });
export const makeItems = (count, extra = {}) => Array.from({ length: count }, () => makeItem(extra));

export const personalizationOptions = [
    { icon: icon1, heading: "Company Name", name: "company_name" },
    { icon: icon2, heading: "Job Title", name: "job_title" },
    { icon: icon3, heading: "Mutual Job", name: "mutual_job" },
    { icon: icon4, heading: "Industry", name: "industry" },
    { icon: icon5, heading: "Location", name: "location" },
];

export const toneOptions = [
    { value: "natural", label: "Natural" },
    { value: "direct", label: "Direct" },
    { value: "friendly", label: "Friendly" },
    { value: "formal_light", label: "Formal Light" },
];

export const emailLengthOptions = [
    { value: "90", label: "60-90" },
    { value: "120", label: "90-120" },
    { value: "150", label: "120-150" },
];
